<template>
<div class="chapter">
<div class="inner_page">
<p class="head">Contents</p>
<p class="toc"><a href="#/acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/chapter1">1. The Archaeological Background</a></p>
<p class="toc"><span href="#/chapter2" title="Link target outside of Sample">2. Life in Etchemin Country at the Dawn of Recorded History</span></p>
<p class="toc"><span href="#/chapter3" title="Link target outside of Sample">3. Defending the Homeland</span></p>
<p class="toc"><span href="#/chapter4" title="Link target outside of Sample">4. Survival and Renewal in an Alien World</span></p>
<p class="toc1"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?403bc69c